import { gql } from "@apollo/client";
import { STORE_INFO_FRAGMENT } from "../../../api/fragments";

export const GET_PICKUP_NOW_COUNT = gql`
  query PickupNowCount($lat: Float, $lng: Float, $limit: Int, $offset: Int) {
    storesV2PickupNow(lat: $lat, lng: $lng, limit: $limit, offset: $offset) {
      id
    }
  }
`;

export const GET_PICKUP_NOW_STORES = gql`
  query PickupNowStores($lat: Float, $lng: Float, $limit: Int, $offset: Int) {
    storesV2PickupNow(lat: $lat, lng: $lng, limit: $limit, offset: $offset) {
      ...StoreInfo
    }
  }
  ${STORE_INFO_FRAGMENT}
`;

export const GET_NEW_STORES_MODAL = gql`
  query StoresV2NewStoresModal($lat: Float, $lng: Float) {
    storesV2NewStoresModal(lat: $lat, lng: $lng) {
      id
      title
      img
      address
      distance
      createdAt
      category
    }
  }
`;

export const GET_NEW_STORES = gql`
  query StoresV2NewStores($lat: Float, $lng: Float) {
    storesV2NewStores(lat: $lat, lng: $lng) {
      id
      title
      img
      isLiked
      distance
      availableStoreCoupon {
        id
        title
        discountValue
        minOrderPrice
        endAt
        maxUsageQuantity
        usageCount
        isExpired
        isSoldOut
      }
    }
  }
`;
